import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Observable } from 'rxjs';
import { SaleNote, SaleNoteFilter } from '..';
import { saleOrderDetailFilter } from '../models/sale/sale-order-detail-filter.model';
import { saleOrderDetail } from '../models/sale/sale-order-detail.model';

@Injectable({
  providedIn: 'root'
})
export class OrderPaymentReadService {
  constructor(
    private apiService: ApiService,
  ) { }

  getDispatchList(body: any): Observable<any> {
    return this.apiService
      .post(`${(this.apiService.orderPaymentRead)}/dispatch-client-guide`, body)
      .pipe();
  }

  getTransactions(params: any): Observable<any> {
    return this.apiService
      .get(`${this.apiService.orderPaymentRead}/transactions`, params)
      .pipe();
  }

  getCancellationTicket(params: any): Observable<any> {
    return this.apiService
      .get(`${this.apiService.orderPaymentRead}/cancellation-ticket`, params)
      .pipe();
  }

  getMissingsData(orderEanCode: any): Observable<any> {
    return this.apiService
      .get(`${this.apiService.orderPaymentRead}/status-missing-picking/${orderEanCode}`)
      .pipe();
  }

  findSaleNotes(saleNoteFilter: SaleNoteFilter): Observable<SaleNote[]> {
    return this.apiService
        .post(`${(this.apiService.orderPaymentRead)}/order-payment`, saleNoteFilter)
        .pipe();
  }

  getDetailDispacth(dispach: saleOrderDetailFilter): Observable<saleOrderDetail[]> {
    return this.apiService
        .post(`${(this.apiService.orderPaymentRead)}/detail`, dispach)
        .pipe();
  }
}
